import React, { FC, useState } from 'react';

import FormField from 'common/components/base/form-field';
import Input from 'common/components/base/input';
import Label from 'common/components/base/label';
import { WhatsNewField, InputType } from 'common/enums';
import { FieldError } from 'common/models';
import FieldErrorList from '../../field-error-list/FieldErrorList';

type AppLinkFormProps = {
    fieldErrors: Array<FieldError>;
    handleNameChange: (event: any) => void;
    handleSortOrderChange: (value: string) => void;
    handleLink: (event: any) => void;
    name: string;
    sortOrder: string;
    link: string;
    validateLink: () => void;
    radioButtonSelected: string;
};

const AppLinkForm: FC<AppLinkFormProps> = ({
    fieldErrors,
    name,
    handleNameChange,
    sortOrder,
    handleSortOrderChange,
    link,
    handleLink,
    validateLink,
    radioButtonSelected
}) => {
    return (
        <div className="whats-new-section">
            <span className="info"> Fill in the below details </span>
            <div className="whats-new-section-form-link">
                <FormField className="whats-new-form-field-link">
                    <Label text="Name (required)"></Label>
                    <Input type={InputType.TEXT} value={name ?? ''} onChange={handleNameChange} />
                    <FieldErrorList field={WhatsNewField.Name} errors={fieldErrors} />
                </FormField>

                <FormField className="whats-new-form-field-link">
                    <Label
                        text={`${radioButtonSelected === 'articleLink' ? 'Article' : 'App'} link`}
                    />
                    <Input
                        type={InputType.TEXT}
                        value={link ?? ''}
                        onChange={handleLink}
                        onBlur={validateLink}
                    />
                    <FieldErrorList
                        field={WhatsNewField.Link}
                        errors={fieldErrors}
                        data-testid="error"
                    />
                </FormField>
            </div>
        </div>
    );
};

export default AppLinkForm;
